<div class="bg-neutral-80 p-2">
  <div class="flex bg-grass-green-120 rounded overflow-hidden">
    <div class="flex w-full">
      @for (step of stepsWithStatus(); track $index) {
        <div
          class="step flex-1 h-[60px] py-[34px] pl-2 pr-3 relative flex justify-center items-center"
          [ngClass]="step.status"
        >
          <div
            class="px-2.5 flex flex-col gap-0.5 justify-center items-center z-20"
          >
            <span
              class="{{ step.icon.type }}-icons icon-14 icon-{{
                step.icon.name
              }} mb-0.5"
            ></span>
            <p
              class="text-body text-center tight"
              [class.bold]="step.status === 'active'"
            >
              {{ step.name | translate }}
            </p>
          </div>
        </div>
      }
    </div>
  </div>
</div>
